(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["reviews-under-media"] && !Shopify.designMode) return;
  try {
    function initReviewsSlider(container) {
    if (!container) return;
    const sliderEl = container.querySelector('.reviews-carousel');
    if (!sliderEl) return;

    const viewDesktop = parseFloat(sliderEl.dataset.viewDesktop || '1.2');
    const viewMobile = parseFloat(sliderEl.dataset.viewMobile || '1.2');
    const gapDesktop = parseInt(sliderEl.dataset.gapDesktop || '16', 10);
    const gapMobile = parseInt(sliderEl.dataset.gapMobile || '12', 10);

    const setupSwiper = () => {
      if (typeof Swiper !== 'undefined') {
        if (sliderEl.swiper) {
          sliderEl.swiper.destroy(true, true);
        }
        new Swiper(sliderEl, {
          speed: 300,
          slidesPerView: viewMobile,
          spaceBetween: gapMobile,
          navigation: {
            nextEl: container.querySelector('.reviews-carousel__next'),
            prevEl: container.querySelector('.reviews-carousel__prev'),
          },
          breakpoints: {
            750: {
              slidesPerView: viewDesktop,
              spaceBetween: gapDesktop,
            },
          },
        });
      } else {
        const wrapper = sliderEl.querySelector('.swiper-wrapper');
        const prevBtn = container.querySelector('.reviews-carousel__prev');
        const nextBtn = container.querySelector('.reviews-carousel__next');

        if (wrapper && prevBtn && nextBtn && !wrapper.dataset.fallbackInit) {
          wrapper.dataset.fallbackInit = 'true';
          prevBtn.addEventListener('click', () => {
            wrapper.scrollBy({ left: -240, behavior: 'smooth' });
          });
          nextBtn.addEventListener('click', () => {
            wrapper.scrollBy({ left: 240, behavior: 'smooth' });
          });
        }
      }
    };

    if (typeof Swiper !== 'undefined') {
      setupSwiper();
    } else {
      window.addEventListener('load', setupSwiper);
      setTimeout(setupSwiper, 300);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.reviews-under-media').forEach((el) => {
      initReviewsSlider(el);
    });
  });

  document.addEventListener('shopify:block:select', (evt) => {
    if (evt.target && evt.target.classList.contains('reviews-under-media')) {
      initReviewsSlider(evt.target);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
